import { useQuery} from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import newRequest from "../../utils/newRequest";
import "./Orders.scss";
import { useNavigate } from "react-router-dom";

const Orders = () => {
  const navigate = useNavigate();
  const [usernames, setUsernames] = useState({});

  // Fetch the orders data
  const {
    isLoading,
    error,
    data: orders,
  } = useQuery({
    queryKey: ["orders"],
    queryFn: () =>
      newRequest.get(`/orders`).then((res) => {
        return res.data;
      }),
  });

  // Fetch user data for each order's seller
  useEffect(() => {
    if (orders) {
      const uniqueSellerIds = [
        ...new Set(orders.map((order) => order.sellerId)),
      ];
      const fetchUsernames = async () => {
        const results = await Promise.all(
          uniqueSellerIds.map((id) =>
            newRequest.get(`/users/${id}`).then((res) => res.data)
          )
        );
        const usernameMap = results.reduce(
          (acc, { _id, username }) => ({ ...acc, [_id]: username }),
          {}
        );
        setUsernames(usernameMap);
      };
      fetchUsernames();
    }
  }, [orders]);

  let errorMessage = "";
  if (error) {
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = error.message;
    }
  }
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {errorMessage}</div>;

  // Get the current user
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  // Handle contact
  const handleContact = async (order) => {
    const sellerId = order.sellerId;
    const buyerId = order.buyerId;
    const id = sellerId + buyerId;
    try {
      const res = await newRequest.get(`/conversations/single/${id}`);
      navigate(`/message/${res?.data?.id}`);
    } catch (err) {
      if (err.response.status === 404) {
        await newRequest.post(`/conversations/`, {
          to: currentUser?.isSeller ? buyerId : sellerId,
        });
      }
    }
  };

  return (
    <div className="orders">
      <div className="orders-container">
        <h1>Orders</h1>
        <table>
          <tr>
            <th>Image</th>
            <th>Title</th>
            <th>Price</th>
            {<th>{currentUser?.isSeller ? "Buyer" : "Seller"}</th>}
            <th>Contact</th>
          </tr>
          {orders &&
            orders.map((order) => (
              <tr key={order?._id}>
                <td>
                  <img className="image" src={order?.img} alt="" />
                </td>
                <td>{order?.title}</td>
                <td>{order?.price}</td>
                <td>{usernames[order?.sellerId] || "Loading..."}</td>
                <td>
                  <img
                    className="message"
                    src="./img/message.png"
                    alt=""
                    onClick={() => handleContact(order)}
                  />
                </td>
              </tr>
            ))}
        </table>
      </div>
    </div>
  );
};

export default Orders;
